package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.example.zone360.models.MenuModel
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Constants.FONT_FAMILY
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul


object DropdownManager {
    private var currentOpenId: String? = null

    fun register(id: String) {
        // Close previous if exists
        currentOpenId?.let { previousId ->
            if (previousId != id) {
                closeDropdown(previousId)
            }
        }
        currentOpenId = id
    }

    fun unregister(id: String) {
        if (currentOpenId == id) {
            currentOpenId = null
        }
    }

    private fun closeDropdown(id: String) {
        try {
            val element = document.getElementById(id)
            if (element != null) {
                val bootstrap = js("window.bootstrap")
                if (bootstrap != null && bootstrap.Dropdown != null) {
                    val instance = bootstrap.Dropdown.getInstance(element)
                    instance?.hide()
                }
            }
        } catch (e: dynamic) {
            // Ignore
        }
    }
}
@Composable
fun MenuDropdown(
    data: List<MenuModel>,
    width: CSSLengthOrPercentageNumericValue? = null,
    title: String? = null,
    textSpanColor: Color? = null,
    icon: (@Composable () -> Unit)? = null,
    onSelect: (String) -> Unit
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val resolvedTextColor = textSpanColor ?: sitePalette.textFieldTextColor.rgb
    // Generate unique ID for each dropdown instance
    val uniqueId = remember { "menuDropDown-${title ?: ""}-${getCurrentMilliseconds().hashCode()}" }
    val uniqueMenuId = remember { "leaderboardDropDown-${title ?: ""}-${getCurrentMilliseconds().hashCode()}" }

    DisposableEffect(uniqueId) {
        onDispose {
            DropdownManager.unregister(uniqueId)
        }
    }

    Box(
        modifier = Modifier
            .id(uniqueId)
            .classNames("dropdown")
            .fillMaxWidth(width ?: 100.percent)
            .alignContent(AlignContent.Center)
            .color(Palette.White.rgbLight)
            .cursor(Cursor.Pointer)
            .onClick { event ->
                event.nativeEvent.stopPropagation()
                DropdownManager.register(uniqueId)
            }
            .attrsModifier {
                attr("data-bs-toggle", "dropdown")
                attr("data-bs-auto-close", "outside")

            }
    ) {
        // Trigger (icon + optional spacer)
        Box(modifier = Modifier.zIndex(0)) {
            icon?.let {
                it()
                CustomSpacer(width = 10.px)
            }
        }

        // Dropdown list
        Box(modifier = Modifier.zIndex(999)) {
            Ul(
                attrs = Modifier
                    .maxWidth(250.px)
                    .id(uniqueMenuId)
                    .classNames("dropdown-menu", "dropdown-menu-end")
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .toAttrs()
            ) {
                data.forEach { item ->
                    Li {
                        menuItem(
                            text = item.text,
                            color = resolvedTextColor,
                            hoverColor = Palette.EditTextBorder.rgbLight // ✅ hover color
                        ) { onSelect(item.text) }
                    }
                }
            }
        }
    }
}

@Composable
fun menuItem(
    color: Color,
    text: String,
    hoverColor: Color.Rgb,
    onSelect: (String) -> Unit
) {
    var isHover by remember { mutableStateOf(false) }

    A(
        attrs = Modifier
            .margin(topBottom = 5.px)
            .classNames("dropdown-item")
            .fontFamily(FONT_FAMILY)
            .fontSize(16.px)
            .backgroundColor(if (isHover) hoverColor else Colors.Transparent) // ✅ hover
            .onMouseEnter { isHover = true }
            .onMouseLeave { isHover = false }
            .onClick { onSelect(text) }
            .toAttrs()
    ) {
        SpanText(
            text = text,
            modifier = Modifier
                .fillMaxWidth()
                .color(color)
                .fontSize(13.px)
                .fontWeight(400)
                .fontFamily(FONT_FAMILY)
        )
    }
}




